import Constants, { AVAILABILITY, BUILDING } from '../../../utils/Constants';
import { getLocales } from '../../../locales/Locale';
import { formateDecimalNumber } from '../../../utils/FormatNumbers';
import {
  calculateIndoorTotal,
  calculateOutdoorTotal,
} from '../../../utils/Calculations';
import { floors } from '../data/InProgressFloors';
import Variables from '../../../style/variables.scss';

const InProgressFilter = ({
  filteredApartments,
  openActiveApartmentModal,
}: {
  filteredApartments: Apartment[];
  openActiveApartmentModal: (apartmentId: string) => void;
}) => {
  const { lang } = getLocales();

  const hasNoApartments =
    !filteredApartments || filteredApartments.length === 0;

  return (
    <div className='inprogress_page_content'>
      {hasNoApartments ? (
        <h3>{lang.InProgressPage.errorFilter}</h3>
      ) : (
        filteredApartments.map((apartment: Apartment) => (
          <div
            className='inprogress_page_content_card'
            key={apartment.building + apartment.apartmentNumber}
            style={{
              backgroundColor: `${
                apartment.availability === AVAILABILITY.RESERVED
                  ? Variables.reserved
                  : apartment.availability === AVAILABILITY.SOLD
                  ? Variables.sold
                  : ''
              }`,
            }}
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <a
              href={`/${Constants.INPROGRESS_PAGE}/${
                apartment.building + apartment.apartmentNumber
              }`}
              onClick={(ele) => {
                ele.preventDefault();
                openActiveApartmentModal(
                  apartment.building + apartment.apartmentNumber
                );
              }}
            >
              {apartment.availability !== AVAILABILITY.FREE && (
                <div className='inprogress_page_content_card_info_flag button_dark'>
                  <div style={{ padding: '0.1rem 1rem' }}>{`${
                    apartment.availability === AVAILABILITY.RESERVED
                      ? 'REZERVIRANO'
                      : apartment.availability === AVAILABILITY.SOLD
                      ? 'PRODANO'
                      : ''
                  }`}</div>
                </div>
              )}
              <img src={apartment.apartmentImg} alt='' />
              <br />
              <div className='inprogress_page_content_card_info'>
                <div className='inprogress_page_content_card_info_total'>
                  <span>
                    Zgrada:{' '}
                    {apartment.building === BUILDING.C
                      ? BUILDING.B
                      : apartment.building}
                  </span>
                  <b>
                    <span>
                      {formateDecimalNumber(
                        calculateOutdoorTotal(apartment) +
                          calculateIndoorTotal(apartment)
                      )}
                      m2
                    </span>
                  </b>
                </div>
                {floors.find((floor) => floor.name === apartment.floor)?.title}
                <br />
                <b>
                  {apartment.name} - {apartment.building}
                  {apartment.apartmentNumber}
                </b>
              </div>
            </a>
          </div>
        ))
      )}
    </div>
  );
};

export default InProgressFilter;
